/* PROJECTS */

export const GET_CALENDAR_EVENTS = "GET_CALENDAR_EVENTS";
export const GET_CALENDAR_EVENTS_SUCCESS = "GET_CALENDAR_EVENTS_SUCCESS";
export const GET_CALENDAR_EVENTS_FAIL = "GET_CALENDAR_EVENTS_FAIL";
